import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ArtificialIntelligenceComponent } from './artificial-intelligence/artificial-intelligence.component';
import { CloudDesignServicesComponent } from './cloud-design-services/cloud-design-services.component';
import { CloudManagedServicesComponent } from './cloud-managed-services/cloud-managed-services.component';
import { CloudModernizationAndMigrationComponent } from './cloud-modernization-and-migration/cloud-modernization-and-migration.component';
import { CloudPlanningServicesComponent } from './cloud-planning-services/cloud-planning-services.component';
import { CloudservicesComponent } from './cloudservices/cloudservices.component';
import { MobileAppDevelopmentComponent } from './mobile-app-development/mobile-app-development.component';
import { DatabaseServicesComponent } from './database-services/database-services.component';
import { OperationMaintananceComponent } from './operation-maintanance/operation-maintanance.component';
import { TechnologyDevelopmentComponent } from './technology-development/technology-development.component';
import { TechnologyStaffingComponent } from './technology-staffing/technology-staffing.component';
import { TechnologyTrainingComponent } from './technology-training/technology-training.component';
import { TestingServicesComponent } from './testing-services/testing-services.component';
import { JourneyCloudComponent } from './journey-cloud/journey-cloud.component';
import { CybersecurityservicesComponent } from './cloudservices/cybersecurityservices/cybersecurityservices.component';
import { ItStaffingComponent } from './it-staffing/it-staffing.component';
const routes: Routes = [
  {path:'artificial-intelligence', component:ArtificialIntelligenceComponent},
  {path:'cloud-design-services', component:CloudDesignServicesComponent},
  {path:'cloud-managed-services', component:CloudManagedServicesComponent},
  {path:'cloud-modernization-and-migration', component:CloudModernizationAndMigrationComponent},
  {path:'cloud-planning-services', component:CloudPlanningServicesComponent},
  {path:'cloudservices', component:CloudservicesComponent},
  {path:'database-services', component:DatabaseServicesComponent},
  {path:'mobileservices', component:MobileAppDevelopmentComponent},
  {path:'operation-maintanance', component:OperationMaintananceComponent},
  {path:'application-services', component:TechnologyDevelopmentComponent},
  {path:'technology-staffing', component:ItStaffingComponent},
  {path:'technology-training', component:TechnologyTrainingComponent},
  {path:'testing-services', component:TestingServicesComponent},
  {path:'journey-to-cloud', component:JourneyCloudComponent},
  {path:'cybersecurityservices',component:CybersecurityservicesComponent},
  // {path:'technology-it-staffing',component:ItStaffingComponent}
  ];


@NgModule({
  declarations: [],
  imports: [
    CommonModule,RouterModule.forChild(routes)
  ]
})
export class ServicesRoutingModule { }
